import * as React from 'react';

import { TertiaryButton } from '@longline/aqua-ui/controls/TertiaryButton';

import { OrganixStatus } from './OrganixStatus';

interface IProps {
  onClose: () => void;
  error: any;
}

const OrganixError = (props: IProps) => {
  return (
    <OrganixStatus>
      <div>The ORGANIX simulation has failed:</div>
      {JSON.stringify(props.error)}
      <TertiaryButton onClick={props.onClose}>OK</TertiaryButton>
    </OrganixStatus>
  )
}

export { OrganixError }
